import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const CasinoProvider = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { loading, data: configData } = useSelector((state) => state.config);

  const [providers, setProviders] = useState([]);

  useEffect(() => {
    if (configData?.casinoProviders) {
      setProviders(configData.casinoProviders);
    }
  }, [configData]);

  const handleGame = (name, sub_provider) => {
    navigate("/provider-games", {
      state: { provider: name, sub_provider: sub_provider },
    });
  };

  return (
    <div className="my-3 mx-2">
      {loading ? (
        <SkeletonTheme baseColor="#868686" highlightColor="#ffffff">
          <div className="grid-container">
            {[...Array(21)].map((_, i) => (
              <Skeleton
                height={200}
                // width={250}
                className="my-1 grid-item"
                key={i}
              />
            ))}
          </div>
        </SkeletonTheme>
      ) : (
        <div className="grid-container">
          {providers.map((item, index) => (
            <div
              className="text-center position-relative"
              onClick={() => {
                handleGame(item.name, item.sub_provider);
              }}
            >
              <img
                key={index}
                src={item.image_url}
                alt=""
                className="grid-item cursor-pointer  "
              />
            </div>
          ))}
          {!loading && providers.length == 0 && (
            <span className="text-white">{t('Common.noDataFound')}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default CasinoProvider;
